import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type { City } from "../client/types/city.types";

const createCityEndpoints = (client: HttpClient = getApi()) => ({
  getAllCities: async (): Promise<City[]> => {
    const { data } = await client.get<City[]>("/cities");
    return data;
  },
  getCityById: async (id: number): Promise<City> => {
    const { data } = await client.get<City>(`/cities/${id}`);
    return data;
  },
});

export type CityEndpoints = ReturnType<typeof createCityEndpoints>;

export const cityEndpoints = createCityEndpoints();
